export const CURRENCIES = {
  USD: {
    code: 'USD',
    symbol: '$',
    name: 'US Dollar'
  },
  NGN: {
    code: 'NGN', 
    symbol: '₦',
    name: 'Nigerian Naira'
  },
  EUR: {
    code: 'EUR',
    symbol: '€',
    name: 'Euro'
  },
  GBP: {
    code: 'GBP',
    symbol: '£',
    name: 'British Pound'
  },
  CAD: {
    code: 'CAD',
    symbol: 'C$',
    name: 'Canadian Dollar'
  },
  AUD: {
    code: 'AUD',
    symbol: 'A$',
    name: 'Australian Dollar'
  },
  JPY: {
    code: 'JPY',
    symbol: '¥',
    name: 'Japanese Yen'
  },
  CHF: {
    code: 'CHF',
    symbol: 'CHF',
    name: 'Swiss Franc'
  },
  CNY: {
    code: 'CNY',
    symbol: '¥',
    name: 'Chinese Yuan'
  },
  INR: {
    code: 'INR',
    symbol: '₹',
    name: 'Indian Rupee'
  }
};

export const CURRENCY_OPTIONS = Object.entries(CURRENCIES).map(([key, currency]) => ({
  value: currency.code,
  label: `${currency.symbol} ${currency.name} (${currency.code})`
})); 